import { type MouseEvent, useCallback, useContext } from "react";

import { useHistory } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OpenNewIcon from "@mui/icons-material/OpenInNewRounded";
import { IconButton, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { cloudReportCardText } from "../../../assets/texts";
import { WidgetMenuWrapperContext } from "../../../Pages/Customer/Dashboards/WidgetsGrid/Header/widgetMenuContext";
import mixpanel from "../../../utils/mixpanel";

type Props = {
  anchorEl: HTMLElement | null;
  hasAccessToReport: boolean;
  helpUrl: string;
  open: boolean;
  reportPath: string;
  thisReportHasData: boolean;
  trackFullReport: () => void;
  handleCloseMenu: () => void;
  handleOpenMenu: (e: MouseEvent<HTMLButtonElement>) => void;
};

export const CloudReportCardMenu = ({
  anchorEl,
  hasAccessToReport,
  helpUrl,
  open,
  reportPath,
  thisReportHasData,
  trackFullReport,
  handleCloseMenu,
  handleOpenMenu,
}: Props) => {
  const handleClickOpenHelp = useCallback(() => {
    mixpanel.track("dashboard.widget.help");
  }, []);
  const history = useHistory();

  const [deleteWidgetOperation] = useContext(WidgetMenuWrapperContext);

  const openFullReport = () => {
    history.push(reportPath);
    trackFullReport();
  };

  return (
    <>
      <IconButton
        id="widget-menu-button"
        aria-controls="basic-menu"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => {
          handleOpenMenu(e);
          e.stopPropagation();
        }}
        aria-haspopup="true"
        size="large"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="widget-menu"
        anchorEl={anchorEl}
        onClick={(e) => {
          e.stopPropagation();
        }}
        open={open}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {hasAccessToReport && <MenuItem onClick={openFullReport}>{cloudReportCardText.OPEN_REPORT}</MenuItem>}

        {Boolean(helpUrl) && thisReportHasData && (
          <MenuItem component="a" href={helpUrl} target="_blank" onClick={handleClickOpenHelp}>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {cloudReportCardText.OPEN_HELP} <OpenNewIcon sx={{ fontSize: 16, marginLeft: 1 }} />
            </Typography>
          </MenuItem>
        )}

        {deleteWidgetOperation && (
          <MenuItem onClick={deleteWidgetOperation}>
            <Typography
              sx={{
                color: "error.main",
              }}
            >
              Remove widget
            </Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
